<template>
	<div class="w1">
	<div  class="website_wrapper" v-loading="loadingMask"><!-- website_wrapper -->
	
	
		<ul class="title1">
			<li class="L">中经头条</li>
			<li class="M"></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			<li ><p><a href="/toutiao" target="_blank">中经头条</a></p><p class="R"></p></li>
		</ul>
		
		
		<ul class="title1">
			<li class="L">中经简报</li>
			<li class="M"></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			<li v-for="(item,index) in jianbaoColList" v-if="item.columnid!='754e208b192747a6baf5382ce3c6719a'"><p><router-link :to="{ name: 'jianbao',params:{column:item.columnname}}" target="_blank">{{item.columnname}}</router-link></p><p class="R"></p></li>
		</ul>
		
		<ul class="title1">
			<li class="L">中经评论</li>
			<li class="M"></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			<li v-for="(item,index) in pinglunColList"><p><router-link :to="{ name: 'pinglun',params:{column:item.columnname}}" target="_blank">{{item.columnname}}</router-link></p><p class="R"></p></li>
		</ul>
		
		<ul class="title1">
			<li class="L">中经数说</li>
			<li class="M"></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			<li ><p><a href="/shushuo" target="_blank">中经数说</a></p><p class="R"></p></li>
		</ul>
		
		<ul class="title1">
			<li class="L">政府公报</li>
			<li class="M"></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			<li v-for="(item,index) in gongbaoColList"><p><router-link :to="{ name: 'gongbao',params:{column:item.columnname}}" target="_blank">{{item.columnname}}</router-link></p><p class="R"></p></li>
		</ul>
		
		<!-- <ul class="title1">
			<li class="L">政策法规</li>
			<li class="M"></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			<li v-for="(item,index) in zhengceColList"><p><router-link :to="{ name: 'zhengce',params:{column:item.columnname}}" target="_blank">{{item.columnname}}</router-link></p><p class="R"></p></li>
		</ul> -->
		
		<ul class="title1">
			<li class="L">发展规划</li>
			<li class="M"></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			<li v-for="(item,index) in guihuaColList"><p><router-link :to="{ name: 'guihua',params:{column:item.columnname}}" target="_blank">{{item.columnname}}</router-link></p><p class="R"></p></li>
		</ul>
		
		<ul class="title1">
			<li class="L">中经专题</li>
			<li class="M"></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			
			<li><p><a href="/zthongguan" target="_blank">宏观经济</a></p><p class="R"></p></li>
			<li><p><a href="/ztxiandaijinrong" target="_blank">现代金融</a></p><p class="R"></p></li>
			<li><p><a href="/ztchanyejingji" target="_blank">产业经济</a></p><p class="R"></p></li>
			<li><p><a href="/ztquyufazhan" target="_blank">区域发展</a></p><p class="R"></p></li>
			<li><p><a href="/ztguojijingji" target="_blank">国际经济</a></p><p class="R"></p></li>
			<li ><p><a href="/ztshuzijingji" target="_blank">数字经济</a></p><p class="R"></p></li>
			<li ><p><a href="/ztshuangtan" target="_blank">碳达峰碳中和</a></p><p class="R"></p></li>
			<li><p><a href="/ztminyingjingji" target="_blank">民间投资</a></p><p class="R"></p></li>
			<li><p><a href="/ztchengshigengxin" target="_blank">城市更新</a></p><p class="R"></p></li>
			<li ><p><a href="/ztxiangcunzhenxing" target="_blank">乡村振兴</a></p><p class="R"></p></li>
			<li ><p><a href="/ztxinxingchengzhenhua" target="_blank">新型城镇化</a></p><p class="R"></p></li>
			<li><p><a href="/ztlianghui" target="_blank">全国两会</a></p><p class="R"></p></li>
			<li><p><a href="/ztgongzuohui" target="_blank">中央经济工作会</a></p><p class="R"></p></li>
			<li><p><a href="/ztjujiao" target="_blank">聚焦二十大</a></p><p class="R"></p></li>
		</ul>
		
		
		
		<!-- <ul class="title1">
			<li class="L"><a href=""  >基础数据库</a></li>
			<li class="R"></li>
		</ul>
		<ul class="list3">
			<li ><p><a href="">政府工作报告</a></p><p class="R"></p></li>
			<li ><p><a href="">发展规划报告</a></p><p class="R"></p></li>
			<li><p><a href="">政府统计公报</a></p><p class="R"></p></li>
			<li  ><p><a href="">经济形势分析报告</a></p><p class="R"></p></li>
			<li ><p><a href="">重要会议</a></p><p class="R"></p></li>
			<li ><p><a href="">领导讲话</a></p><p class="R"></p></li>
			<li ><p><a href="">政策方针</a></p><p class="R"></p></li>
			<li ><p><a href="">专家视点</a></p><p class="R"></p></li>
			<li ><p><a href="">典型案例库</a></p><p class="R"></p></li>
			<li><p><a href="">财政预决算</a></p><p class="R"></p></li>
		</ul> -->
	
		
		
		
	</div><!-- /website_wrapper -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: true,
				jianbaoColList:[],
				pinglunColList:[],
				gongbaoColList:[],
				zhengceColList:[],
				guihuaColList:[],
			}
		},
		created:function(){
			
		},
		mounted:function(){
			document.title='网站导航-中经专网';
			this.$track([
				['pagetype','网站导航']
			]);
			this.jianbaocolumfnc();
			this.pingluncolumfnc();
			this.gongbaocolumfnc();
			// this.zhengcecolumfnc();
			this.guihuacolumfnc();
		},
		methods: {
			jianbaocolumfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'column/selectAllByparentID',
						responseType: 'json',
						params: {
							parentID: '57fd9c2506ea4afabadb154e1b79a148',
						},
					})
					.then(function(response) {
						_this.jianbaoColList=response.data.data.data;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMask = false;
					});;
			},
			pingluncolumfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'column/selectAllByparentID',
						responseType: 'json',
						params: {
							parentID: '6a79e1b0f6d7411583d38c43c4e3eafc',
						},
					})
					.then(function(response) {
						_this.pinglunColList=response.data.data.data;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMask = false;
					});;
			},
			gongbaocolumfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'column/selectAllByparentID',
						responseType: 'json',
						params: {
							parentID: '4d8d655b07414efcadb75ab9e630f20a',
							attribute: 0,
						},
					})
					.then(function(response) {
						_this.gongbaoColList=response.data.data.data;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMask = false;
					});;
			},
			zhengcecolumfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'column/selectAllByparentID',
						responseType: 'json',
						params: {
							parentID: '69c194d171704e64a2d30dbb12270c76',
						},
					})
					.then(function(response) {
						_this.zhengceColList=response.data.data.data;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMask = false;
					});;
			},
			guihuacolumfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'column/selectAllByparentID',
						responseType: 'json',
						params: {
							parentID: '3847e82aa95e4626a472c4e9299c4c55',
							attribute: 0,
						},
					})
					.then(function(response) {
						_this.guihuaColList=response.data.data.data;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						console.log(error);
						_this.loadingMask = false;
					});;
			},
		}
	}
</script>

<style>
</style>
